<template>
    <re-b-modal ref="upload" header="手动上传图纸" fit-content
                no-close-on-backdrop no-ok-button @cancel="clear">
        <div class="d-flex flex-column" style="min-width: 400px;">
            <FileUpload :action="uploadDrawingAction" :accept="accept"
                        append-mode multiple
                        :put-before-upload="putConfig"
                        :badgeVariantIs="badgeVariantIs"
                        @fileChange="whenDrawingSelected"
                        @fileRemove="whenDrawingRemove"
                        @success="whenUploadSuccess">
            </FileUpload>
            <mini-table ref="drawingConfig"
                        v-if="Object.values(this.drawings).length>0"
                        read-only class="mt-1 flex-grow-1"
                        :items="Object.values(this.drawings)"
                        effect-origin-row
                        :fields="uploadFields"
                        row-key="fileOriginName"
                        addition-columns="documentName,fileOriginName"
                        custom-columns="_isNew">
                <template #custom(_isNew)="{row}">
                    <div v-if="!documentNumbers.hasOwnProperty(row.documentName)">
                        <i class="fa-solid fa-plus text-success"></i>
                        新图
                    </div>
                    <div v-else>
                        <template v-if="documentNumbers[row.documentName]">
                            <i class="fa-solid fa-left-long"></i>
                            {{ documentNumbers[row.documentName] }}
                        </template>
                        <i class="fa-solid fa-angles-up text-info"></i>
                        升版
                    </div>
                </template>

                <template #addition(documentName)="{row}">
                    <div style="max-width: 200px;" class="d-flex flex-wrap">
                        <template v-for="(item,i) of fileNameSplit[row.fileOriginName]">
                            <b-badge :variant="item.selected ? 'success' : ''"
                                     :key="i" class="ml-1 mt-1"
                                     @click="splitNameClick(row, item)">
                                {{ item.str }}
                            </b-badge>
                        </template>
                    </div>
                </template>

                <template #addition(fileOriginName)="{val}">
                    <div v-if="existFileNames.has(val)"
                         data-toggle="tooltip"
                         title="文件名重复"
                         class="ml-2">
                        <i class="fa-solid fa-question text-danger"></i>
                    </div>
                </template>
            </mini-table>
        </div>
    </re-b-modal>
</template>

<script>
import FileUpload from "@/components/common/inputs/FileUpload.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "DrawingUpload",
    components: {MiniTable, ReBModal, FileUpload},
    props: {
        material: {
            type: String
        }
    },
    data() {
        return {
            accept: '.pdf',
            drawings: {},
            uploadFields: [
                {key: 'fileOriginName', label: '文件名'},
                {key: 'documentName', label: '图纸号', isInput: true, flexColumn: true},
                {key: 'version', label: '版本号', isInput: true},
                {key: '_isNew', label: '上传类型'},
            ],
            documentNumbers: {},
            existFileNames: new Set(),
            fileNameSplit: {},
        }
    },
    computed: {
        uploadDrawingAction() {
            if (this.material) {
                return process.env.VUE_APP_SITHMESII_PDS_URL + "/materialDrawing/upload/fromUser?material=" + this.material;
            }
            return null;
        },
    },
    methods: {
        show() {
            this.$refs.upload.showModal();
            this.getMaterialDocumentNumbers();
        },
        getVersion: function (str) {
            let i = str.search(/[^a-z0-9]/i);
            if (i === -1) {
                i = str.length;
            }
            return str.substring(0, i);
        },
        whenDrawingSelected(fileNames) {
            for (let name of fileNames) {
                if (!this.drawings[name]) {
                    let temp = {
                        fileOriginName: name
                    };
                    let mainName = name;
                    let dotIndex = name.lastIndexOf('.');
                    if (dotIndex > -1) {
                        mainName = name.substring(0, dotIndex);
                    }
                    console.log(name, mainName, dotIndex)
                    let isNew = true;
                    for (let number of Object.keys(this.documentNumbers)) {
                        let index = mainName.indexOf(number);
                        if (index > -1) {
                            temp.documentName = number;
                            isNew = false;
                            let str = mainName.substring(index + number.length);
                            if (str.startsWith('_')) {
                                str = str.substring(1);
                                temp.version = this.getVersion(str);
                            }
                        }
                    }
                    if (isNew) {
                        let ss = mainName.split('_');
                        if (ss.length === 1) {
                            temp.documentName = ss[0];
                        } else if (ss.length === 2) {
                            temp.documentName = ss[0];
                            temp.version = this.getVersion(ss[1]);
                        } else {
                            let tempList = [];
                            for (let s of ss) {
                                tempList.push({
                                    str: s,
                                    selected: false
                                })
                            }
                            this.fileNameSplit[name] = tempList;
                        }
                    }
                    this.drawings[name] = temp;
                }
            }
            this.$forceUpdate();
        },
        whenDrawingRemove(name) {
            if (this.drawings[name]) {
                this.$delete(this.drawings, name);
            }
            this.fileNameSplit[name] = undefined;
        },
        putConfig(param) {
            let value = this.$refs.drawingConfig.columnEditData();
            param.append('config', JSON.stringify(value))
        },
        whenUploadSuccess() {
            this.$message.success("上传完成");
            this.clear();
            this.$refs.upload.hide();
        },
        //----
        getMaterialDocumentNumbers() {
            if (this.material) {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/sithMomMaterialDrawingInfo/documents/version?material=" + this.material,
                    commonErrorHandle: false
                }).then(response => {
                    if (response) {
                        if (response.documentNumbers) {
                            let temp = {};
                            for (let item of response.documentNumbers) {
                                temp[item.documentNumber] = item.version;
                            }
                            this.documentNumbers = temp;
                        }
                        if (response.fileNames) {
                            let temp = new Set();
                            for (let name of response.fileNames) {
                                temp.add(name);
                            }
                            this.existFileNames = temp;
                        }
                    }
                });
            }
        },
        clear() {
            this.drawings = {};
            this.fileNameSplit = {};
        },
        splitNameClick(row, item) {
            this.$set(item, 'selected', !item.selected);
            let tempList = [];
            let fileOriginName = row.fileOriginName;
            for (let s of this.fileNameSplit[fileOriginName]) {
                if (s.selected) {
                    tempList.push(s.str);
                }
            }
            this.$set(this.drawings[fileOriginName], 'documentName', tempList.join('_'));
            this.$forceUpdate();
        },
        badgeVariantIs(name) {
            return this.existFileNames.has(name) ? 'primary' : '';
        },
    }
}
</script>

<style scoped>

</style>
